'use client'
import { Flex, Text } from '@mantine/core'
import { useTranslations } from 'next-intl'

import ChevronRight from '@/assets/icons/chevron-right.svg'
import { I18nLink } from '@/i18n/navigation'

import { useStockContext } from '../_contexts/StockContext'

export default function StockDetailHeader() {
  const { stock } = useStockContext()
  const t = useTranslations('common')

  return (
    <Flex align={'center'} mb={32}>
      <I18nLink href={'/'} prefetch={true}>
        <Text c={'var(--content-secondary)'} variant={'subtitle'}>
          {t('Market')}
        </Text>
      </I18nLink>
      <ChevronRight height={16} fill={'var(--content-tertiary)'} />
      <Text variant={'subtitle'} c={'var(--content-primary)'}>
        {stock.name}
      </Text>
    </Flex>
  )
}
